import captureSpecificError from '../capture-error';

// eslint-disable-next-line import/prefer-default-export
export const initialize = () => {
  const appsFlyerAppId = window?.DECKEE_CONFIG?.appsFlyer?.appId;
  const appsFlyerDevKey = window?.DECKEE_CONFIG?.appsFlyer?.devKey;
  if (window?.plugins?.appsFlyer && appsFlyerAppId && appsFlyerDevKey) {
    try {
      //   This is only required for iOS devices hence the appID is from the apple store
      const appsFlyerOptions = {
        devKey: appsFlyerDevKey,
        appId: appsFlyerAppId,
        isDebug: false,
        waitForATTUserAuthorization: 10,
      };

      window.plugins.appsFlyer.initSdk(
        appsFlyerOptions,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        () => {},
        (error) => {
          captureSpecificError(
            error,
            'containers/app-main-client/src/services/appsflyer/index.js',
          );
        },
      );

      window.plugins.appsFlyer.logEvent('af_app_opened', {});
    } catch (error) {
      try {
        captureSpecificError(
          error,
          'containers/app-main-client/src/services/appsflyer/index.js',
        );
      } catch {
        // If it fails to log the error, oh well...
      }
      // eslint-disable-next-line no-console
      console.log(
        `An error occurred while initializing AppsFlyer: ${error?.message}`,
      );
    }
  }
};
